export default "__VITE_ASSET__Dq2hC1N3__"